/* eslint-disable react-hooks/exhaustive-deps */
import {Grid} from "@mui/material";
import {HotelCard} from "./HotelCard";
import React,{useState} from "react";
import { HotelService } from "../../Admin/Hotel/services/hotelService";
import { UserContext } from "../../../contexts/AppContext";

const hotelService = new HotelService();
export const ChoiceHotel = (props:any) => {
    const [dataSelected, setDataSelected] = useState([]);

    const [isSelected, setIsSelected] = useState(false);
    const userContext = React.useContext(UserContext);
    const [hotel, setHotel] = React.useState<any>([]);
    const [, setLoadingPage] = React.useState(true);
    // const [detail,setDetail]= React.useState<any>()
  const { user,  } = userContext;
    const handleSelect = () => {

        setIsSelected(!isSelected)
    }
    React.useEffect(()=>{
        if(user._id !== ""){
            hotelService.getHotelByUser(user._id).then(response=>{
                if(response.success){
                    setHotel(response.hotel)
                    setLoadingPage(false)
                }
            }).catch(err=>{
                setLoadingPage(false)
            })
        }
    },[setLoadingPage, setHotel, user])

    return (
        <Grid container flexDirection="row" gap={3} justifyContent={"center"}>
            { hotel.length>0 && hotel.map((item:any) => (
                <HotelCard 
                    item={item}
                    handleClick={handleSelect} 
                    setIsSelected={setIsSelected}
                    isSelected={isSelected}
                    id={item._id} 
                    data={dataSelected} 
                    setData={setDataSelected}
                    companyName={item.companyName}
                    image={item.photos}
                    description={item.description}
                    onClickHotel={props.onClickHotel}
                    setHotel={props.setHotel}
                    />
            ))}
        </Grid>
    )
}